var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgWatchClockIconDark = function SvgWatchClockIconDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 12a9.25 9.25 0 10-18.5 0 9.25 9.25 0 0018.5 0z",
    stroke: "#fff",
    strokeOpacity: 0.8,
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.425 12.7v.006a.921.921 0 01-.931.907h-2.678a.868.868 0 01-.9-.85l.026-5.708a.89.89 0 01.905-.857h.006a.869.869 0 01.9.85l-.019 4.752H14.5a.916.916 0 01.928.9h-.003z",
    fill: "#fff",
    fillOpacity: 0.8
  })));
};
export default SvgWatchClockIconDark;